<template>
  <div class="scrollable">
  	<v-header></v-header>
    <div class="content">
    	<div class="breadNav">
        <p>{{$t('m.staffMealDetail.brankNav')}}</p>
      </div>
      <div class="mealName">
        <p class="icon"></p>
        <p class="name">{{$t('m.staffMealDetail.meal')}}：{{datajson.name}}</p>
        <p class="msg">{{$t('m.staffMealDetail.mealNum1')}}{{datajson.check_item_count}}{{$t('m.staffMealDetail.mealNum2')}}{{$t('m.staffMealDetail.mealNum3')}}</p>
      </div>
      <div class="details" v-for="(item,index) in datajson.items">
        <div class="tit">
          <p>{{item.name}}</p>
        </div>
        <el-table
        :data="item.items"
        border
        stripe
        style="width: 100%">
        <el-table-column
          prop="name"
          :label="$t('m.staffMealDetail.medicalItems')"
          width="180">
        </el-table-column>
        <el-table-column
          prop="content"
          :label="$t('m.staffMealDetail.checkItems')"
          width="500">
        </el-table-column>
        <el-table-column
          prop="clinic_mean"
          :label="$t('m.staffMealDetail.examinationSignificance')">
        </el-table-column>
      </el-table>
      </div>
      <div class="back" @click="backBtn">
        <p>{{$t('m.common.goBack')}}</p>
      </div>
    </div>
  	<v-footer></v-footer>
  </div>
</template>

<script>
import axios from 'axios'; 
import {mapActions, mapGetters} from 'vuex';
import header from '../../common/header.vue'  
import footer from '../../common/footer.vue'  
export default {
	name: 'setMealDetails',
	data () {
	    return {
        datajson:{}
	    }
  	},
  	components: {
	    "v-header": header,
	    "v-footer":footer
	},
  	created() {
  		let _this = this;
      let id = _this.$route.query.id;
      let project_id = _this.$route.query.id;
      // console.log(id,project)
      //获取套餐详情接口
      axios.get(BASE_URL+'/exam/combos/'+id+'/?project='+project_id).then((res)=>{
        console.log(res);
        _this.datajson = res.data.data;
      })
    },
  	methods:{
  		backBtn(){
        let _this = this;
        _this.$router.go(-1);
      }

  	},
  	computed: {
  	  // ...mapGetters(['resturantName','resturantId']) // 动态计算属性，相当于this.$store.getters.resturantName
  	}
}
</script>

<style scoped>
  .back{
    width: 1180px;
    height: 46px;
    background: #f2f2f2;
    margin:0 auto;
    margin-top: 20px;
    margin-bottom: 124px;
    display: flex;
    justify-content: flex-end;
  }
  .back p{
    width: 180px;
    height: 46px;
    background: #E51E26;
    font-size:20px;
    
    /*font-weight:600;*/
    color:#fff;
    line-height:20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .details{
    width: 1180px;
    margin: 0 auto;
  }
  .details .tit{
    width: 100%;
    height: 46px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    background:rgba(2,128,201,0.0969); 
    margin-top: 30px;
    display: flex;
    align-items: center;
    padding-left: 20px;
  }
  .details .tit p{
    font-size:16px;
    
    font-weight:600;
    color:#333;
    line-height:16px;
  }
  .mealName{
    width: 1180px;
    height: 78px;
    border:1px solid #ccc;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 30px;
  }
  .mealName .icon{
    width: 4px;
    height: 18px;
    background: #e94709;
  }
  .mealName .name{
    font-size:18px;
    
    font-weight:600;
    color:#333;
    line-height:18px;
    margin-left: 7px;
  }
  .mealName .msg{
    font-size:14px;
    
    font-weight:400;
    color:#e94709;
    line-height:16px;
    margin-left: 10px;
  }
  .breadNav{
    width: 100%;
    height: 80px;
    border-bottom: 2px solid #EAEAEA;
    display: flex;
    align-items: center;
  }
  .breadNav p{
    width: 1180px;
    margin: 0 auto;
    font-size:18px;
    
    font-weight:600;
    color:#333;
    line-height:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/phyExServices/selfPhyExService/setMealDetails.vue